import { defineStore } from "pinia";

export const useContacts = defineStore("contacts", {
  state: () => ({
    contacts: [],
  }),

  actions: {
    async loadContacts() {
      let contacts = await window.$A.ApproverService.AllIndexed();
      this.contacts = contacts;
    },
  },
});
